"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M6.7 18.29c.39.39 1.02.39 1.41 0L12 14.42l3.88 3.88c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L12.7 12.3a.996.996 0 0 0-1.41 0L6.7 16.88c-.39.39-.39 1.02 0 1.41"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M6.7 11.7c.39.39 1.02.39 1.41 0L12 7.83l3.88 3.88c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L12.7 5.71a.996.996 0 0 0-1.41 0L6.7 10.29c-.39.39-.39 1.02 0 1.41"
}, "1")], 'KeyboardDoubleArrowUpRounded');